export const SIDEBAR_MIDDLE_LIST_PADDING_Y = 12;
export const SIDEBAR_MIDDLE_LIST_PADDING_X = 8;
export const SIDEBAR_ATOM_ROW_HEIGHT = 30;
export const SIDEBAR_ATOM_GAP = 0;
export const SIDEBAR_ATOM_STEP = SIDEBAR_ATOM_ROW_HEIGHT + SIDEBAR_ATOM_GAP;
export const SIDEBAR_CREATE_BUTTON_SIZE = SIDEBAR_ATOM_ROW_HEIGHT;
export const SIDEBAR_MENU_ITEM_ICON_SIZE = 20;
export const SIDEBAR_EXPANDABLE_HEADER_PADDING_Y = 12;
export const SIDEBAR_EXPANDABLE_ACTION_HEADER_HEIGHT =
  SIDEBAR_CREATE_BUTTON_SIZE + 2 * SIDEBAR_EXPANDABLE_HEADER_PADDING_Y;
export const SIDEBAR_EXPANDABLE_LIST_GAP = 8;
export const SIDEBAR_EXPANDABLE_LIST_PADDING_Y =
  SIDEBAR_EXPANDABLE_LIST_GAP / 2;
export const SIDEBAR_REORDER_GAP_CSS_VAR = '--streamlain-sidebar-reorder-gap';
